import type { ApiEnvelope } from '../types';
import type { ApiModuleDeps } from './internal/request';
import type {
    OnboardingCompleteRequest,
    OnboardingCompleteResponse,
    OnboardingConfigResponse,
} from '../types';

export function createOnboardingApi({ authHttp, noAuthHttp }: ApiModuleDeps) {
    return {
        createConsultation(request: {
            name?: string;
            email?: string;
            message?: string;
        }): Promise<ApiEnvelope<Record<string, never>>> {
            return noAuthHttp.post('/consultations', request);
        },
        getConfig(): Promise<ApiEnvelope<OnboardingConfigResponse>> {
            return authHttp.get('/onboarding/config');
        },
        complete(
            request: OnboardingCompleteRequest
        ): Promise<ApiEnvelope<OnboardingCompleteResponse>> {
            return authHttp.post('/onboarding/complete', request);
        },
    };
}
